// For QuickAnswer the default and selected layer 2 topic list
import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  display: false,
  selected: false, // To tracking quick answers: whether selected or not
  topics: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_RELATED_TOPIC:
      return { ...state, isLoading: true, error: false };
    case types.RECEIVE_RELATED_TOPIC_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: false,
        topics: action.payload,
      };
    case types.RECEIVE_RELATED_TOPIC_ERROR:
      return { ...state, isLoading: false, error: true };
    default:
      return state;
  }
}
